import type { CmsPageCollectionItems } from '$cms/types';
import type { VrmLookupTranslatedEntities } from '../../types';

export function getVrmLookupImage(
  translatedEntities: VrmLookupTranslatedEntities,
  collections: CmsPageCollectionItems = {}
): string | undefined {
  const { product, area, carMake, carModel } = collections;
  const { backgroundImage } = translatedEntities;

  if ((area && !product?.image) || (carMake && carModel && !product)) {
    return undefined;
  }
  if (product?.image) {
    return product.image;
  }
  if (carMake?.image && !carModel) {
    return carMake.image;
  }
  if (backgroundImage?.url) {
    return backgroundImage.url;
  }
  return undefined;
}
